import styles from './CaseStudy.module.scss'

interface CaseList {
  src: string
  alt: string
  exName: string
  type: string
  introduction: string
}

const caseLists: CaseList[] = [
  {
    src: '/images/lp2/05_casestudy/case_1.jpg',
    alt: '企業G様のケース',
    exName: '企業G様のケース',
    type: 'デザインスプリント',
    introduction:
      '新規サービスの検討にあたって部署横断でのチームを構成してデザインスプリントを実施しました。スプリント期間中は、オンラインとオフラインを組み合わせてのアイディエーションとワークショップをプロダクトデザイン部、開発、営業の各担当者、総勢20名弱の混成メンバーで実施しています。また、このプロジェクトではスプリントを1週するだけでなく、複数の切り口でのサービスを検討するために連続で6回のスプリントを回す計画にカスタマイズして実施しました。このプロジェクトを通して生まれたアイデアをラピッドプロトタイピングとユーザーテストで検証するまでスピード感を持って実施できたことはプロジェクトオーナーと経営層にも高くご評価いただいています。',
  },
  {
    src: '/images/lp2/05_casestudy/case_2.jpg',
    alt: '企業K様のケース',
    exName: '企業K様のケース',
    type: 'サービスデザイン',
    introduction:
      'DXにおけるデジタライゼーションによる新規サービスの創出を行いたい企業は多いと思います。化学メーカーである同社もデザイン思考を取り入れてのDXを社内でも議論はしていたものの、実際のプロジェクト化においては二の足を踏んでいました。そのためデジタルを活用したサービス創造のためのアイディエーションを行う前に、関連部署のキーパーソンを中心にイノベーション創出ためのワークショッププログラムを実施しました。プログラム内容は、マシュマロタワーといった体を使ったアイスブレークから、ビジネスモデル研究といった課題でデジタルサービスをUXの視点、お金の流れといった観点から課題ワークとグループディスカッション構成からなっています。参加メンバーは30名弱であったため一つのチームを5名程度にし6チームでITサービスのビジネスモデル検討からアイデアコンテストを実施しています。',
  },
  {
    src: '/images/lp2/05_casestudy/case_3.jpg',
    alt: '企業A様のケース',
    exName: '企業A様のケース',
    type: 'UX・コンセプト設計〜UI・ビジュアルデザイン',
    introduction:
      '元々ゴルフコンペ用に作られたアプリのUIリニューアルとしてお話をいただきましたが、ユーザーインタビューからペルソナ設計やユースケースなどを考慮した結果、アプリコンセプトを再考することに。ストイックなアマチュアゴルファーを対象ペルソナとし、再度アイディエーションとプロトタイピングを行い、ラウンド記録と分析に特化したアプリにリニューアルしました。',
  },
]

const CaseStudy: React.FC = () => {
  const caseList = caseLists.map(({ src, alt, exName, type, introduction }) => (
    <li key={src} className={styles.li}>
      <div className={styles.imgWrapper}>
        <img className={styles.img} src={src} alt={alt} />
      </div>
      <div className={styles.listTextWrapper}>
        <p className={styles.exNameText}>{exName}</p>
        <p className={styles.typeText}>{type}</p>
        <p className={styles.introductionText}>{introduction}</p>
      </div>
    </li>
  ))
  return (
    <>
      <section className={styles.caseStudy} id="CaseStudy">
        <div className={styles.box}></div>
        <div className={styles.mainWrapper}>
          <div className={styles.textWrapper}>
            <p className={`${styles.redText} ${styles.introText}`}>
              <span className={styles.redBox}></span>Case study
            </p>
            <h3 className={styles.h3}>
              企業の様々なケースに
              <br />
              ご対応いたします
            </h3>
            <p className={styles.topText}>
              企業のニーズに合わせて組み合わせる
              <br />
              多様なフレームワークをご用意しています。
            </p>
          </div>
          <ul className={styles.ul}>{caseList}</ul>
        </div>
        <a className={styles.a} href="/case" target="_blank" rel="noopener">
          事例一覧はこちら<span className={styles.redBall}></span>
        </a>
      </section>
    </>
  )
}

export default CaseStudy
